export default __webpack_public_path__ + "static/lizThoughtDishroom-fe45a875a02306e890526914c24147a3.svg";